// Mock data for Likith's portfolio (frontend-only)

export const profile = {
  name: 'LIKITH',
  caption: "You're being watched",
  tagline: 'Digital creator / Editor / Designer',
  aboutLines: [
    "Hey, I'm Likith",
    "I work in the digital space \u2014 editing videos, designing thumbnails, creating content, and building clean websites. I mainly use Canva, Adobe Express, and WordPress to get things done fast and smooth.",
    'I also help people finish their projects without the usual struggle, and if you need premium tools, I can hook you up with them for around 50% of the original price.',
    "If it's online, creative, or needs a clean look \u2014 I've probably got you covered.",
  ],
  batmanImage: 'https://customer-assets.emergentagent.com/job_e02caf51-9ffd-4057-8bdd-70425900e9a3/artifacts/w6qpd0ne_batman-chromebook-wallpaper.jpg',
  upiQrImage: 'https://customer-assets.emergentagent.com/job_midnight-creative/artifacts/d1vkwzp3_image.png',
};

// ----- SERVICES -----
export const featuredServices = [
  {
    id: 'svc-poster',
    code: '01',
    title: 'Poster Making',
    short: 'Eye-catching posters \u2014 any vibe, any niche.',
    bullets: ['Event \u00b7 club \u00b7 movie \u00b7 brand posters', 'Custom typography & color', 'Print + social-ready exports'],
  },
  {
    id: 'svc-content',
    code: '02',
    title: 'Content Writing',
    short: 'Captions, scripts, articles \u2014 written to land.',
    bullets: ['Hook-first captions', 'Long-form articles & blogs', 'Reel / YouTube scripts'],
  },
  {
    id: 'svc-website',
    code: '03',
    title: 'Website Making',
    short: 'Clean, fast WordPress & landing sites.',
    bullets: ['Portfolio & business sites', 'Landing pages that convert', 'Responsive on every device'],
  },
];

export const allServices = [
  {
    id: 'svc-poster',
    code: '01',
    title: 'Poster Making',
    desc: 'All kinds of posters \u2014 events, clubs, movies, gym, food, business, festival, birthday, even meme posters \u2014 designed at very, very cheap prices. You bring the idea, I bring the visuals.',
    perks: ['Any niche, any vibe', 'Custom typography & color', 'High-res print + social ready', 'Unlimited revisions until perfect', 'Very cheap rates \u2014 DM for a quote'],
  },
  {
    id: 'svc-content',
    code: '02',
    title: 'Content Writing',
    desc: 'Captions that hook, scripts that flow, articles that read. SEO-friendly long-form, punchy short-form, and on-brand voice across the board.',
    perks: ['Reel / YouTube scripts', 'Blog articles & SEO posts', 'Insta / Twitter captions', 'Brand tone matching', 'Plagiarism-free, AI-polished'],
  },
  {
    id: 'svc-website',
    code: '03',
    title: 'Website Making',
    desc: 'Clean, modern sites built on WordPress, Webflow, or simple HTML \u2014 portfolios, landing pages, small-business sites, link-in-bio pages. Fully responsive and ready to ship in days.',
    perks: ['Portfolio sites', 'Landing pages', 'Business / shop sites', 'Mobile-first responsive', 'SEO basics included'],
  },
  {
    id: 'svc-thumb',
    code: '04',
    title: 'Thumbnail Design',
    desc: 'Scroll-stopping YouTube and Reel thumbnails designed to lift CTR. Bold faces, clean text, perfect contrast.',
    perks: ['YouTube + Reel + Short formats', 'CTR-optimised composition', 'Fast turnaround \u2014 24h'],
  },
  {
    id: 'svc-edit',
    code: '05',
    title: 'Video Editing',
    desc: 'Reels, shorts, long-form cuts. Clean pacing, color, sound, and subtitles \u2014 delivered fast.',
    perks: ['Reels / Shorts / Long-form', 'Subtitles + sound design', 'Color grading'],
  },
  {
    id: 'svc-project',
    code: '06',
    title: 'Project Assistance',
    desc: 'Stuck on a college, school, or personal project? I help you finish it without the usual struggle \u2014 docs, design, research, slides.',
    perks: ['College / school projects', 'Slides, docs, reports', 'Research + design'],
  },
];

// ----- STORE -----
// Logo style: 'M' for Monogram (single letter), 'I' for Icon (lucide), 'X' for custom svg, 'C' for Cyber (jammer)
export const allStoreProducts = [
  { id: 'p-spotify',  name: 'Spotify Premium',     letter: 'S', perks: ['No ads', 'Offline downloads', 'High-quality audio', '1-year individual'], price: '\u20b9499 / yr' },
  { id: 'p-netflix4k-fa',  name: 'Netflix 4K (FA)',     letter: 'N', perks: ['Full account access', '4K Ultra-HD streaming', '4 simultaneous screens', '1-year'], price: '\u20b9899 / yr' },
  { id: 'p-netflix4k-nfa', name: 'Netflix 4K (NFA)',    letter: 'N', perks: ['Shared profile', '4K Ultra-HD', 'Genuine subscription', '1-year'], price: '\u20b9499 / yr' },
  { id: 'p-canva',    name: 'Canva Pro',           letter: 'C', perks: ['Premium templates', 'Background remover', 'Magic Resize', '1-year'], price: '\u20b9399 / yr' },
  { id: 'p-adobeexp', name: 'Adobe Express',       letter: 'A', perks: ['All premium features', 'Stock photos & fonts', 'Pro templates', '1-year'], price: '\u20b9599 / yr' },
  { id: 'p-adobecc',  name: 'Adobe Creative Cloud', letter: 'A', perks: ['All Adobe apps', 'Photoshop \u00b7 Premiere \u00b7 Illustrator', 'Genuine keys', '1-year access'], price: '\u20b91499 / yr' },
  { id: 'p-yt',       name: 'YouTube Premium',     letter: 'Y', perks: ['No ads, ever', 'Background play', 'YouTube Music included', '1-year'], price: '\u20b9399 / yr' },
  { id: 'p-cr',       name: 'Crunchyroll Premium', letter: 'C', perks: ['Ad-free anime', 'New episodes 1h after Japan', 'Offline viewing', '1-year'], price: '\u20b9349 / yr' },
  { id: 'p-prime',    name: 'Prime Video',         letter: 'P', perks: ['HD + 4K shows', 'Movies + originals', 'Multiple devices', '1-year'], price: '\u20b9599 / yr' },
  { id: 'p-chatgpt',  name: 'ChatGPT Plus',        letter: 'G', perks: ['GPT-4o / GPT-5 access', 'Faster replies', 'Image + voice features', '1-month / shared'], price: '\u20b9799 / mo' },
  { id: 'p-grammarly',name: 'Grammarly Pro',       letter: 'G', perks: ['Advanced grammar', 'Tone + clarity', 'Plagiarism checker', '1-year'], price: '\u20b9449 / yr' },
  { id: 'p-mc',       name: 'Minecraft (Java + Bedrock)', letter: 'M', perks: ['Genuine Microsoft account', 'Java + Bedrock both', 'Full ownership', 'Lifetime'], price: '\u20b9299' },
  { id: 'p-rockstar', name: 'Rockstar Games Pack', letter: 'R', perks: ['GTA V + RDR2 + more', 'Genuine Rockstar account', 'PC keys', 'Lifetime'], price: '\u20b9999' },
  { id: 'p-xbox',     name: 'Xbox Game Pass Ultimate', letter: 'X', perks: ['100s of games', 'Xbox + PC + cloud', 'EA Play included', '1-month'], price: '\u20b9249' },
  { id: 'p-psplus',   name: 'PS Plus Premium',     letter: 'P', perks: ['Online multiplayer', 'Monthly free games', 'PS5 + PS4 catalogue', '1-month'], price: '\u20b9349' },
  { id: 'p-applecv',  name: 'Apple TV+',           letter: 'A', perks: ['Apple originals', '4K HDR streaming', 'Multi-device', '1-year'], price: '\u20b9299' },
  { id: 'p-sonyliv',  name: 'Sony LIV Premium',    letter: 'S', perks: ['LIV originals + sports', 'HD streaming', 'No ads', '1-year'], price: '\u20b9249' },
  { id: 'p-jiohotstar',name:'JioHotstar Premium',  letter: 'J', perks: ['Live sports + IPL', 'HD + Dolby', 'Hotstar specials', '1-year'], price: '\u20b9499' },
];

// 6 to feature on the home preview
export const featuredStore = [
  'p-spotify', 'p-netflix4k-fa', 'p-canva', 'p-adobeexp', 'p-yt', 'p-chatgpt'
].map((id) => allStoreProducts.find((p) => p.id === id));

// Special bundle
export const bundleProduct = {
  id: 'p-bundle',
  name: 'Unlimited Single-Time-Use Premium Accounts',
  tagline: 'One pack \u2014 dozens of premium logins, free to use once.',
  price: '$50',
  perks: [
    'Crunchyroll Premium',
    'Grammarly Pro',
    'Fap House Ultra',
    'Apple TV',
    'Sony LIV',
    'Jio Hotstar',
    'Netflix Premium',
    'Spotify Premium',
    'YouTube Premium',
    'Prime Video',
    'Canva Pro',
    'Adobe Express',
    'And many more, more, more...',
  ],
};

// Cyber tools
export const cyberProducts = [
  {
    id: 'cy-bt',
    name: 'Bluetooth Jammer',
    short: 'Pocket-sized BT signal disruptor.',
    perks: ['Disrupts nearby BT 2.4 GHz devices', '\u2248 8\u201310 m effective range', 'USB-C rechargeable, 6h runtime', 'Compact PCB, anodised aluminium'],
    price: '\u20b91999',
  },
  {
    id: 'cy-wifi',
    name: 'Bluetooth + Wi-Fi Jammer',
    short: 'Dual-band BT + 2.4/5 GHz Wi-Fi disruptor.',
    perks: ['BT + Wi-Fi simultaneous', '\u2248 15\u201320 m effective range', 'Dual antenna, heavy-duty PCB', 'Type-C charging, 4h runtime'],
    price: '\u20b93499',
  },
];

// ----- SMM -----
export const smmHighlight = {
  platform: 'Instagram',
  network: 'instagram',
  items: ['Followers', 'Likes', 'Views'],
  description:
    'Real, retention-tested social media growth. Genuine engagement on Instagram, YouTube, and Snapchat \u2014 priced fairly, delivered cleanly.',
};

export const smmDescription = [
  'Real, retention-tested social media growth.',
  'Genuine engagement \u2014 Instagram, YouTube, Snapchat.',
  'Priced fairly, delivered cleanly.',
];

export const smmPlatforms = [
  {
    id: 'smm-ig',
    platform: 'Instagram',
    network: 'instagram',
    services: [
      { name: 'Views',      from: '\u20b949 / 1k' },
      { name: 'Likes',      from: '\u20b969 / 1k' },
      { name: 'Followers',  from: '\u2079\u20b9249 / 1k' },
    ],
  },
  {
    id: 'smm-yt',
    platform: 'YouTube',
    network: 'youtube',
    services: [
      { name: 'Subscribers', from: '\u20b9499 / 1k' },
      { name: 'Likes',       from: '\u20b9149 / 1k' },
      { name: 'Watch Hours', from: '\u20b9799 / 1k h' },
    ],
  },
  {
    id: 'smm-sc',
    platform: 'Snapchat',
    network: 'snapchat',
    services: [
      { name: 'Followers', from: '\u20b9299 / 1k' },
      { name: 'Likes',     from: '\u20b9199 / 1k' },
    ],
  },
];

// ----- CONTACT -----
export const contacts = [
  { id: 'c-ig',    label: 'Instagram', handle: '@liki9th',          url: 'https://instagram.com/liki9th',    network: 'instagram', priority: 1 },
  { id: 'c-dc',    label: 'Discord',   handle: 'liki9th',           url: '#',                                 network: 'discord',   priority: 1 },
  { id: 'c-mail',  label: 'Email',     handle: 'lgkx4d@gmail.com',  url: 'mailto:lgkx4d@gmail.com',           network: 'email',     priority: 1 },
  { id: 'c-phone', label: 'Phone',     handle: '+91 76708 29170',   url: 'tel:+917670829170',                 network: 'phone',     note: "Often not the best way \u2014 I rarely pick up calls. DM me on Instagram instead.", priority: 2 },
];

// ----- DONATE -----
export const donateTiers = [
  { id: 'd-01', amount: 49,  label: 'Coffee',  note: 'A small thanks' },
  { id: 'd-02', amount: 199, label: 'Fuel',    note: 'Keep the edits flowing' },
  { id: 'd-03', amount: 499, label: 'Sponsor', note: 'Back the grind' },
  { id: 'd-04', amount: null,label: 'Custom',  note: 'Choose your own' },
];

export const upiInfo = {
  id: '7670829170@fam',
  name: 'Likith',
  qrImage: 'https://customer-assets.emergentagent.com/job_midnight-creative/artifacts/d1vkwzp3_image.png',
};

export const cryptoWallets = [
  { id: 'btc', name: 'Bitcoin',  ticker: 'BTC', address: 'bc1qyqfykwuyhuvtyeua9vxym75gfcqcu4sdmq34uq' },
  { id: 'eth', name: 'Ethereum', ticker: 'ETH', address: '0xb028ee1B42Ff805C36f70bc1Df099aca3F8c3c3c' },
  { id: 'ltc', name: 'Litecoin', ticker: 'LTC', address: 'ltc1qq8j8ymmp4g3czlw2zzsgp499xqjyru72v4ct4v' },
];

export const navItems = [
  { id: 'hero', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'services', label: 'Services' },
  { id: 'store', label: 'Store' },
  { id: 'smm', label: 'SMM' },
  { id: 'contact', label: 'Contact' },
  { id: 'donate', label: 'Donate' },
];
